module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/Pjc2y73M4RYd4Yta9m7Vv-88eb44f62686136342669266ca5210f7.jpg";